import { date } from 'quasar'
import * as Enumerable from 'linq-es2015'
import ProcessedFilesEndPointAddModel from './processedfilesendpointaddmodel-dialog-screen.vue';


export default {
    props: {
        index: Number,
        modelId: Object,
        modelObject: Object,
        actionLabel: String,
        actionTitle: String,
        editMode: Boolean,
        parentScreenParameters: Object
    },

    mixins: [],

    components: {
        
    },

    data: function () {
        return {
            screenKey: "ProcessedFilesSettingsEditModel",
            loading: false,
            actionLocked: false,
            model: this.emptyModel(),
            modelErrors: null,
            modelMetadata: {
                EndPoints: {
                    loading: false,
                    filter: null,
                    columns: [
                        {
                    name: 'Id',
                    label: 'Id',
                    align: 'left',
                    field: row => row.Id,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'ConfigId',
                    label: 'ConfigId',
                    align: 'left',
                    field: row => row.ConfigId,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'EndPointType',
                    label: 'EndPointType',
                    align: 'left',
                    field: row => row.EndPointType,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'EndPointTypeConverted',
                    label: 'Type',
                    align: 'left',
                    field: row => row.EndPointTypeConverted,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'Name',
                    label: 'Name',
                    align: 'left',
                    field: row => row.Name,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => true
                },
                {
                    name: 'IsDeleted',
                    label: 'IsDeleted',
                    align: 'left',
                    field: row => row.IsDeleted,
                    sortable: false,
                    style: '',
                    
                    isVisible: () => false
                },
                {
                    name: 'Actions',
                    label: 'Actions',
                    align: 'center',
                    field: row => row.Actions,
                    sortable: false,
                    style: '',
                    isVisible: () => true
                },

                    ],
                    columnsVisible: ['EndPointTypeConverted', 'Name', 'Actions'],
                    pagination: { rowsPerPage: 0 },
                    localTimezoneOffset: new Date().getTimezoneOffset(),
                },

            },
            
            applicationResources: null,
            toolTipStates: {},
            dataSourceCustomerConfigurationType: [],
            dataSourceEndPointType: [],
            dataSourceLookupTradingPartners: [],
            dataSourceProcessedFileCreateDateRangeType: [],

        }
    },

    computed: {
        screenTitle: function () {
            return 'of the Processed Files';
        },

        EndPoints: function () { 
            return this.model.EndPoints?.filter(item => {
                return item.IsDeleted === false;
            }) ?? [];
        },

    },

    methods: {
        fieldHasError: function (field) {
            return this.modelErrors != null && this.modelErrors.hasOwnProperty(field);
        },

        fieldErrorMessage: function (field) {
            if (this.modelErrors == null) {
                return '';
            }

            if (this.modelErrors.hasOwnProperty(field) === false) {
                return '';
            }
            
            return this.modelErrors[field];
        },

        

        emptyModel() {
            return {
                Id: 0,
                Root: null,
                ConfigurationType: null,
                RootSeller: null,
                RootWarehouse: null,
                SalesChannels: [],
                Warehouses: [],
                Sellers: [],
                DateRange: null,
                NotificationEnabled: false,
                NotificationEmail: null,
                EndPoints: [],

            }
        },

        onEndPointsCreateActionClick(id) {
            if (this.actionLocked) {
                return;
            }
            this.actionLocked = true;   
                
            this.$q.dialog({
                component: ProcessedFilesEndPointAddModel,
                parent: this,
                index: 0,
                modelId: null,
                modelObject: this.$prepareDialogModel(this.model),
                actionLabel: 'Save',
                actionTitle: 'Create',
                editMode: true
            }).onOk((payload) => {
                payload.model.Id = this.$generateTemporaryId(payload.model.Id);
                payload.model.IsDeleted = false;
                this.model.EndPoints.splice(0, 0, payload.model);
                
            }).onDismiss(() => {
                this.actionLocked = false;
            });
        },

        onEndPointsRemoveItemActionClick(rowKey, rowIndex, row) {
            if (this.actionLocked) {
                return;
            }
            try {
                this.actionLocked = true;

                let currentItemIndex = this.model.EndPoints.map(e => { return e.Id ? e.Id : e.Key; }).indexOf(rowKey);
                this.model.EndPoints[currentItemIndex].IsDeleted = true;
                this.model.EndPoints.splice(currentItemIndex, 1, this.model.EndPoints[currentItemIndex]);
                
            }
            finally {
                this.actionLocked = false;
            }
        },

        onCustomerConfigurationTypeStaticDataSource() {
            this.dataSourceCustomerConfigurationType = JSON.parse('[{"Key":0,"Value":"Vendor Setup"},{"Key":1,"Value":"Warehouse Setup"}]');
        },

        onEndPointTypeStaticDataSource() {
            this.dataSourceEndPointType = JSON.parse('[{"Key":0,"Value":"Undefined"},{"Key":1,"Value":"File Watcher"},{"Key":2,"Value":"Pop3"},{"Key":3,"Value":"EC Grid"}]');
        },

        onProcessedFileCreateDateRangeTypeStaticDataSource() {
            this.dataSourceProcessedFileCreateDateRangeType = JSON.parse('[{"Key":0,"Value":"Last day"},{"Key":1,"Value":"Last 3 days"},{"Key":2,"Value":"Last week"}]');
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                if (((typeof this.modelId === 'number') && this.modelId > 0) ||
                    ((typeof this.modelId === 'string') && this.modelId !== '')) {
                    if(true){
                    let url = this.$prepareServerUrl('/api/ui/processed_files_applications/{id}', this.modelId, this.modelObject, this.$route.params);
                    let response = await this.$http.get(url, {  });
                    if (this.$processServerJsonResponse(response.body) == false) {
                        this.model = response.body;
                        
                        
                    }
                } 
                else {
                    this.model = this.emptyModel();
                    this.$applyModelFields(this.modelObject, this.model);
                }
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },

        async onSaveModelDataSource() {
            try {
                this.loading = true;
                this.modelErrors = null;

                let url = this.$prepareServerUrl('/api/ui/processed_files_applications/{id?}', this.modelId, this.modelObject, this.$route.params);
                let response = await this.$http.post(url, this.model, {  });

                this.$processServerJsonResponse(response.body, this.refreshScreen);

                this.model = response.body;
                return true;
            }
            catch (ex) {
                if (ex.body.errors) {
                    this.modelErrors = ex.body.errors;
                   return false;
                } else {
                    this.$processException(ex);    
                }

                return false;
            }
            finally {
                this.loading = false;
            }
        },

        async onLookupTradingPartnersLookupDataSource(parentValue) {
            
            let url = '/api/ui/trading_partners/lookup';
            url = this.$prepareServerUrl(url, this.modelId, this.modelObject ?? this.model);
            let response = await this.$http.get(url);
            this.dataSourceLookupTradingPartners = response.body;
        },

        onConfigurationTypeChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceCustomerConfigurationType).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onDateRangeChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceProcessedFileCreateDateRangeType).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onRootSellerChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTradingPartners).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onRootWarehouseChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTradingPartners).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onSalesChannelsChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTradingPartners).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onSellersChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTradingPartners).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        onWarehousesChange(model, value) {
            // Refresh model fields from selected item.
            let valueItem = value?.Item;

            if (!valueItem) {
                let dsItem = Enumerable.AsEnumerable(this.dataSourceLookupTradingPartners).FirstOrDefault(e => e.Key == value);

                if (dsItem) {
                    if (dsItem.hasOwnProperty('Item'))
                        valueItem = dsItem.Item;
                    else if (dsItem.hasOwnProperty('Value'))
                        valueItem = dsItem.Value;
                }
            }

            if (valueItem) {
                for (var propertyName in valueItem) {
                    if (model.hasOwnProperty(propertyName)) {
                        model[propertyName] = valueItem[propertyName];
                    }
                }
            }

            // Refresh cascade lookups.
            

            // Custom OnChange action.
            
        },

        
        onLoadFieldDataSources() {
            this.onCustomerConfigurationTypeStaticDataSource();
            this.onEndPointTypeStaticDataSource();
            this.onProcessedFileCreateDateRangeTypeStaticDataSource();
            this.onLookupTradingPartnersLookupDataSource();

        },

        async show() {
            await this.onLoadModelDataSource();
                this.onLoadFieldDataSources();
            this.$refs.dialog.show();
        },

        hide() {
            this.$refs.dialog.hide();
        },

        async onDialogHide() {
            this.$emit('hide');
            
        },

        async onOkClick() {
            if(this.actionLocked)
                return;
            try {
                this.actionLocked = true;
                let validateResult = await this.$refs.modelForm.validate();
                if (validateResult) {
                    let saveResult = await this.onSaveModelDataSource();
                if (saveResult) {
                    this.$emit('ok', { index: this.index, model: this.model, files: null });
                    this.hide();
                }
                }
            }
            finally {
                this.actionLocked = false;
            }
        },

        onCancelClick() {
            this.hide();
        }
    }
}